module.exports = __webpack_public_path__ + "static/img/15.f13b97b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/15.png
// module id = SooK
// module chunks = 0